<template>
  <!-- 线下专题培训 + 继续教育课程 -->
  <div class="trainingCourse">
    <div class="tc-contain">
      <!-- 线下专题培训 -->
      <div class="animate__animated animate__fadeInLeftBig tc-contain-left">
        <talentTitle title="线下专题培训">
          <template #btn>
            <div class="curp" @click="onClickCourseMore">
              查看更多
            </div>
          </template>
        </talentTitle>
        <div class="box-con">
          <div v-for="(item, index) in trainList" :key="index" class="trainItem">
            <div class="trainItem-bg" :style="{
              backgroundImage: `url(https://static.zhuzaocloud.com/${item.logo})`,
            }"></div>
            <div class="trainItem-content">
              <div class="trainItem-content-title over-num-lines" :title="item.name">{{ item.name }}</div>
              <div class="trainItem-content-profile">
                <div>
                  报名时间：{{ item.liveBeginTime.split(" ")[0] }}~{{
              item.liveEndTime.split(" ")[0]
            }}
                </div>
                <div>
                  培训时间：{{ item.courseStartTime.split(" ")[0] }}~{{
              item.courseEndTime.split(" ")[0]
            }}
                </div>
                <div class="over-num-lines" :title="item.address">培训地点：{{ item.address }}</div>
              </div>
              <!-- status: '0'未开始，'1'进行中，'2'已结束 -->
              <el-popover placement="top" width="200" trigger="click" class="el-popover-box">
                <wechart-qr-code ref="wechartQrCode1"></wechart-qr-code>
                <div slot="reference" @click="resClickEvet1(item, index)">
                  <div v-if="item.status == '1'" class="trainItem-content-entryBtn1">
                    点击报名
                  </div>
                </div>
              </el-popover>
              <div v-if="item.status == '0'" class="trainItem-content-entryBtn2">
                未开始
              </div>
              <div v-else-if="item.status == '2'" class="trainItem-content-entryBtn2">
                报名结束
              </div>
              <!-- <div v-else class="trainItem-content-entryBtn2">报名结束</div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 分隔线 -->
      <!-- <div class="dividerLine"></div> -->
      <!-- 继续教育课程 -->
      <div class="animate__animated animate__fadeInRightBig tc-contain-right">
        <talentTitle title="继续教育课程">
          <template #subTitle>
            <div class="subtitle">（工业工程类）</div>
          </template>
          <template #btn>
            <div class="curp" @click="onClickCourseMore">
              查看更多
            </div>
          </template>
        </talentTitle>
        <div class="box-con">
          <div v-for="(item, index) in courseList" :key="index" class="trainItem">
            <div class="trainItem-bg" :style="{
              backgroundImage: `url(https://static.zhuzaocloud.com/${item.logo})`,
            }"></div>
            <div class="trainItem-content">
              <div class="trainItem-content-title over-num-lines" :title="item.name">{{ item.name }}</div>
              <div class="trainItem-content-profile">
                <div>
                  报名时间：{{ item.liveBeginTime.split(" ")[0] }}~{{
              item.liveEndTime.split(" ")[0]
            }}
                </div>
                <div>
                  培训时间：{{ item.courseStartTime.split(" ")[0] }}~{{
              item.courseEndTime.split(" ")[0]
            }}
                </div>
                <div class="over-num-lines" :title="item.address">培训地点：{{ item.address }}</div>
              </div>
              <!-- status: '0'未开始，'1'进行中，'2'已结束 -->
              <el-popover placement="top" width="200" trigger="click" class="el-popover-box">
                <wechart-qr-code ref="wechartQrCode2"></wechart-qr-code>
                <div v-if="item.status == '1'" class="trainItem-content-entryBtn1" slot="reference"
                  @click="resClickEvet2(item, index)">
                  点击报名
                </div>
              </el-popover>
              <div v-if="item.status == '0'" class="trainItem-content-entryBtn2" slot="reference">
                未开始
              </div>
              <div v-else-if="item.status == '2'" class="trainItem-content-entryBtn2" slot="reference">
                报名结束
              </div>
              <!-- <div v-else class="trainItem-content-entryBtn2" slot="reference">报名结束</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourse } from "../../utils/interface"
import talentTitle from "./talentTitle.vue"
import wechartQrCode from "./wechartQrCode"
export default {
  name: "trainingCourse",
  components: { talentTitle, wechartQrCode },
  props: {},
  data() {
    return {
      trainList: [
        // {
        //     logo: require('../../assets/publicService/talentService/11.png'),
        //     name: '制造装备类“双师型”教师专题培训班',
        //     courseStartTime: '',
        //     courseEndTime: '',
        //     liveBeginTime: '',
        //     liveEndTime: '',
        //     address: '浙江 · 宁波',
        //     status: '1'
        // }
      ],
      courseList: [
        // {
        //     logo: require('../../assets/publicService/talentService/33.png'),
        //     name: '制造装备类“双师型”教师专题培训班',
        //     courseStartTime: '',
        //     courseEndTime: '',
        //     liveBeginTime: '',
        //     liveEndTime: '',
        //     address: '浙江 · 宁波',
        //     status: '2'
        // }
      ]
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.getOnlineCourse()
    this.getOffLineCourse()
  },
  methods: {
    // 获取线上课程
    getOnlineCourse() {
      getCourse({
        currentPage: "1",
        pageSize: "2",
        courseStatus: "0",
        sellType: "COURSE",
      }).then((res) => {
        if (res && res.list.length > 0) {
          this.courseList = res.list
        } else {
          this.courseList = []
        }
      })
    },
    // 获取线下课程
    getOffLineCourse() {
      getCourse({
        currentPage: "1",
        pageSize: "2",
        courseStatus: "0",
        sellType: "LINEDOWN",
      }).then((res) => {
        if (res && res.list.length > 0) {
          this.trainList = res.list
        } else {
          this.trainList = []
        }
      })
    },
    // 培训-查看更多
    onClickCourseMore() {
      let route = this.$router.resolve({
        path: "/trainingCourseList",
      })
      window.open(route.href, "_blank")
    },
    resClickEvet1(item, index) {
      // console.log('item', item)
      if (item.status == 1) {
        this.$refs.wechartQrCode1[index].initData(item.id, item.logoUrl)
      }
    },
    resClickEvet2(item, index) {
      // console.log('item', item)
      if (item.status == 1) {
        this.$refs.wechartQrCode2[index].initData(item.id, item.logoUrl)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.trainingCourse {
  height: 420px;
  background: url("../../assets/publicService/talentService/9.png") no-repeat center center / 100% 100%;

  .curp {
    cursor: pointer;

    &:hover {
      color: #2d50a1;
    }
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .tc-contain {
    width: 1300px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .dividerLine {
      height: 400px;
      border-right: 0.5px solid #e4e4e4;
    }

    .tc-contain-left,
    .tc-contain-right {
      width: 630px;
      height: 390px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-around;

      .box-con {
        height: 400px;
        padding: 4px 10px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;

        .trainItem {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          box-shadow: 0 0 3px #cdbbbbb0;
          border-radius: 12px;
          box-sizing: border-box;
          transition: all 0.2s;

          &:hover {
            cursor: pointer;
            transform: scale(1.02);
          }

          .trainItem-bg {
            width: 270px;
            height: 160px;
            border-top-left-radius: 12px;
            border-bottom-left-radius: 12px;
            background: no-repeat center center/100% 100%;
          }

          .trainItem-content {
            flex: 1;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 12px 18px;

            .trainItem-content-title {
              color: #000;
              font-size: 16px;
              font-weight: 600;
            }

            .trainItem-content-profile {
              color: #8a8a8a;
              font-size: 14px;
            }

            .trainItem-content-entryBtn1,
            .trainItem-content-entryBtn2 {
              font-size: 14px;
              width: 90px;
              height: 30px;
              color: #fff;
              text-align: center;
              line-height: 30px;
              border-radius: 4px;
              background-color: #2e509e;
              // cursor: pointer;
            }

            .trainItem-content-entryBtn2 {
              background-color: #b5b5b5;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/trainingCourse.vue